import FormFieldAPI from './form_field_api';

/**
 * @class LabelFormFieldAPI
 * @extends FormFieldAPI
 */
class LabelFormFieldAPI extends FormFieldAPI {
	errors() {
		console.warn(Realize.i18n.t('form.warnNotPropAPILabel'));
		return this;
	}
}

export default LabelFormFieldAPI
